import factory from './icon';
import Svg from './glyphs/zoom-out.svg';

export default factory(Svg);
